export const SET_ADMIN_USER = 'ADMIN_USER/SET_ADMIN_USER'
export const SET_ADMIN_USERS = 'ADMIN_USER/SET_ADMIN_USERS'
